<template>
  <div>
    <el-row :gutter="15" class="mt-4">
      <el-col :span="12">
        <h4>Variant Inventory</h4>
      </el-col>
      <el-col :span="12">
        <product-item-inventory-create :variantId="variantId" @create="getInventories"/>
      </el-col>
    </el-row>
    <el-table :data="inventories" style="width: 100%;" empty-text="No variant inventories were found." v-loading="loading">
      <el-table-column label="Distributor">
        <template slot-scope="props">
          <router-link :to="{ name: 'distributor-id', params: { id: props.row.distributor.id } }">{{ props.row.distributor.name }}</router-link>
        </template>
      </el-table-column>
      <el-table-column label="SKU" prop="sku"></el-table-column>
      <el-table-column label="Quantity" prop="stock.available"></el-table-column>
      <el-table-column label="Operations">
        <template slot-scope="props">
          <product-item-inventory-edit :inventory="props.row" @update="getInventories">
            <el-button type="primary" size="mini" plain>
              Edit
            </el-button>
          </product-item-inventory-edit>
          <product-item-inventory-delete :id="props.row.id" @delete="getInventories"/>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import ProductItemInventoryCreate from '@/components/Product/Item/ProductItemInventoryCreate'
import ProductItemInventoryEdit from '@/components/Product/Item/ProductItemInventoryEdit'
import ProductItemInventoryDelete from '@/components/Product/Item/ProductItemInventoryDelete'

export default {
  components: {
    ProductItemInventoryCreate,
    ProductItemInventoryEdit,
    ProductItemInventoryDelete,
  },
  props: {
    variantId: String,
  },
  data() {
    return {
      loading: false,
      inventories: [],
    }
  },
  mounted() {
    this.getInventories()
  },
  methods: {
    async getInventories() {
      this.loading = true
      this.inventories = []

      try {
        var { data } = await this.$http.get(`/inventories`, {
          params: { variant_id: this.variantId }
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.inventories = data
    },
  },
}
</script>
